import { render, staticRenderFns } from "./BottomBtn.vue?vue&type=template&id=9e1907ee&scoped=true&"
import script from "./BottomBtn.vue?vue&type=script&lang=js&"
export * from "./BottomBtn.vue?vue&type=script&lang=js&"
import style0 from "./BottomBtn.vue?vue&type=style&index=0&id=9e1907ee&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e1907ee",
  null
  
)

export default component.exports